<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-row>
            <v-col cols="12">
              <v-container py-0 fluid>
                <v-row justify="end" align="center">
                  <v-col sm="3">
                    <v-select
                      v-if="showGroupedView"
                      :items="groupByOptions"
                      v-model="selectedGroupedBy"
                      label="Group by"
                      item-text="name"
                      return-object
                      :outlined="outlinedInputs"
                      hide-details
                      width="200px"
                    ></v-select>
                  </v-col>
                  <v-switch
                    prepend-icon="mdi-view-list"
                    class="pr-3"
                    label="Group View"
                    v-model="showGroupedView"
                  ></v-switch>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
          <v-row v-if="showGroupedView">
            <v-col cols="12">
              <v-container fluid>
                <list-grouped :group="selectedGroupedBy" :items="items">
                  <template v-slot:table="{ items }">
                    <v-card outlined>
                      <open-group-items-table
                        :items="items"
                        :headers="headers"
                        :search="search"
                        :templateDays="templateDays"
                        :duration="duration"
                        @onItemRemove="onItemRemove"
                        @onSaveServiceDuration="onSaveServiceDuration"
                        @onSaveServiceDay="onSaveServiceDay"
                        @onExtraRemove="onExtraRemove"
                        @supplier-edit="onSupplierEdit"
                        @itemIncludedChange="onItemIncludedChange"
                        @onItemRemarks="onItemRemarks"
                      ></open-group-items-table>
                    </v-card>
                  </template>
                </list-grouped>
              </v-container>
            </v-col>
          </v-row>

          <open-group-items-table
            v-else
            :items="items"
            :headers="headers"
            :search="search"
            :templateDays="templateDays"
            :duration="duration"
            @onItemRemove="onItemRemove"
            @onSaveServiceDuration="onSaveServiceDuration"
            @onSaveServiceDay="onSaveServiceDay"
            @onExtraRemove="onExtraRemove"
            @supplier-edit="onSupplierEdit"
            @itemIncludedChange="onItemIncludedChange"
            @onItemRemarks="onItemRemarks"
          ></open-group-items-table>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <v-col><code>{{ items }}</code></v-col>
    </v-row>
  </v-container>
</template>

<script>
import { SupplierTypeIconMixin } from "../../../../mixins/SupplierTypeIconMixin";
import ListGrouped from "../../shared/ListGrouped";
import OpenGroupItemsTable from "./OpenGroupItemsTable";
export default {
  name: "OpenGroupItemsList",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    duration: {
      type: Number,
      default: () => 7,
    },
  },

  mixins: [SupplierTypeIconMixin],

  components: {
    ListGrouped,
    OpenGroupItemsTable,
  },

  data() {
    return {
      debug: false,
      showGroupedView: false,
      selectedGroupedBy: {
        name: "Day",
        getKey: (item) => item.startDay,
        getLabel: (item) => `Day No: ${item.startDay}`,
      },
      groupByOptions: [
        {
          name: "Day",
          getKey: (item) => item.startDay,
          getLabel: (item) => `Day No: ${item.startDay}`,
        },
        {
          name: "Supplier Type",
          getKey: (item) => item.serviceType,
          getLabel: (item) => `${item.serviceType}`,
        },
        {
          name: "Supplier",
          getKey: (item) => item.supplierName,
          getLabel: (item) => `${item.supplierName}`,
        },
      ],
      search: "",
      headers: [
        {
          text: "Type",
          value: "serviceType",
          sortable: false,
          name: "serviceType",
        },
        {
          text: "Day",
          value: "startDay",
          sortable: false,
          name: "startDay",
        },
        {
          text: "Duration",
          value: "duration",
          sortable: false,
          name: "duration",
        },
        {
          text: "Order",
          value: "order",
          sortable: true,
          name: "order",
        },
        {
          text: "Supplier",
          value: "supplierName",
          sortable: false,
          name: "supplierName",
        },
        {
          text: "Service Name",
          value: "serviceName",
          sortable: false,
          name: "serviceName",
        },
        {
          text: "Rate Plan",
          value: "ratePlan",
          sortable: false,
          name: "ratePlan",
        },
        {
          text: "Qty",
          value: "qty",
          sortable: false,
          name: "qty",
        },
        {
          text: "Adults",
          value: "adults",
          sortable: false,
          name: "adults",
        },
        {
          text: "Children",
          value: "children",
          sortable: false,
          name: "children",
        },
        {
          text: "No Report",
          value: "hidden",
          sortable: false,
          name: "hidden",
        },
        {
          text: "Included",
          value: "included",
          sortable: false,
          name: "included",
        },
        {
          text: "Optional",
          value: "optional",
          sortable: false,
          name: "optional",
        },
        { text: "Actions", value: "actions", sortable: false, name: "actions" },
      ],
    };
  },

  computed: {
    templateDays() {
      return [...Array(this.duration).keys()].map((i) => ++i);
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    onItemIncludedChange(item) {
      const editedItem = this.items.find((i) => i.id == item.id);
      if (editedItem) {
        for (const extra of editedItem.extras) {
          extra.included = item.included;
        }
      }
      this.$emit("itemIncludedChange", editedItem);
    },
    onSaveServiceDay(item) {
      const maxDuration = this.duration - Number(item.startDay);
      if (Number(item.duration) > maxDuration) {
        item.duration = maxDuration;
      }
      this.updateItemExtras(item);
    },
    onSaveServiceDuration(item) {
      this.updateItemExtras(item);
    },
    updateItemExtras(item) {
      for (const extra of item.extras) {
        extra.startDay = item.startDay;
        extra.duration = item.duration;
      }
    },
    onItemRemove(item) {
      this.$emit("remove-item", item);
    },
    onItemRemarks(item) {
      this.$emit("onItemRemarks", item);
    },
    onExtraRemove(extra, item) {
      const editedItem = this.items.find((i) => i.id == item.id);
      if (editedItem) {
        editedItem.extras = [
          ...editedItem.extras.filter((e) => e.id != extra.id),
        ];
        if (editedItem.extras.length == 0) {
          this.expanded = [...this.expanded.filter((i) => i.id != item.id)];
        }
      }
    },
    onSupplierEdit(payload) {
      this.$emit("supplier-edit", payload);
    },
  },
};
</script>

<style>
.t-items-table tr td:first-child:not(:only-child) {
  width: 80px;
}
.t-items-table tr td:last-child:not(:only-child) {
  width: 100px;
}
.t-items-table tr td:nth-child(2),
.t-items-table tr td:nth-child(3),
.t-items-table tr td:nth-child(4) {
  width: 100px;
}
.t-items-table tr td:nth-child(5),
.t-items-table tr td:nth-child(6) {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/open-groups/builder/OpenGroupItemsList.vue